import { ROLES } from "../common/Const";

export const MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.OPERATOR, ROLES.TEACHER];

const getActiveRole = principal => (typeof principal === "string" ? principal : principal && principal.role);
const getSystemRoles = principal => (
  principal && Array.isArray(principal.systemRoles) ? principal.systemRoles : []
);
const hasAnyRole = (principal, roles) => (
  roles.includes(getActiveRole(principal)) ||
  getSystemRoles(principal).some(role => roles.includes(role))
);

export const getEffectivePermissionRole = (principal) => {
  if (hasAnyRole(principal, [ROLES.ADMIN])) return ROLES.ADMIN;
  if (hasAnyRole(principal, [ROLES.OPERATOR])) return ROLES.OPERATOR;
  return getActiveRole(principal);
};

export const isManageRole = principal => (
  MANAGEMENT_ROLES.includes(getActiveRole(principal)) ||
  hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR])
);
export const isTeacher = principal => getActiveRole(principal) === ROLES.TEACHER;
export const canReadClients = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canReadBooks = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canReadPayments = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageClasses = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageClassStudents = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageSettings = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManagePermissions = principal => hasAnyRole(principal, [ROLES.ADMIN]);

export function canAccessManagePath(principal, pathname) {
  if (!isManageRole(principal)) return false;
  if (pathname.startsWith("/manage/permissions")) return canManagePermissions(principal);
  if (pathname.startsWith("/manage/settings")) return canManageSettings(principal);
  if (pathname.startsWith("/manage/clients") || pathname.startsWith("/manage/client/")) return canReadClients(principal);
  if (pathname.startsWith("/manage/books") || pathname.startsWith("/manage/book/")) return canReadBooks(principal);
  if (pathname.startsWith("/manage/teachers") || pathname.startsWith("/manage/teacher/")) return !isTeacher(principal) || hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
  if (pathname.startsWith("/manage/student/")) return !isTeacher(principal) || hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
  if (pathname.startsWith("/manage/reports/client-settlements")) return canReadPayments(principal);
  return true;
}
